<template>
  <div class="mt-2 d-flex flex-row pointer" @click.stop="object[field] = !object[field]">
    <i v-if="object[field]" class="fas fa-toggle-on text-success mt-1 ms-1"></i>
    <i v-else-if="!object[field]" class="fas fa-toggle-off text-secondary mt-1 ms-1"></i>
    <div class="ms-2">{{label}}</div>
  </div>
</template>

<script>
  export default {
    name: 'OnOffControl',
    props: ['field', 'label', 'object']
  }
</script>
